import type { DeviceDto, LocationDto, ScheduleDto } from "@repo/data-store";
import { createContext, type ReactNode, useContext } from "react";

interface ScheduleCalendarContext {
  schedules: ScheduleDto[];
  locations: LocationDto[];
  devices: DeviceDto[];
}

const ScheduleCalendarCtx = createContext<ScheduleCalendarContext>({
  schedules: [],
  locations: [],
  devices: [],
});

export function ScheduleCalendarProvider({
  schedules,
  locations,
  devices,
  children,
}: ScheduleCalendarContext & { children: ReactNode }) {
  return (
    <ScheduleCalendarCtx.Provider value={{ schedules, locations, devices }}>{children}</ScheduleCalendarCtx.Provider>
  );
}

export function useScheduleCalendarContext() {
  return useContext(ScheduleCalendarCtx);
}
